import * as z from 'zod';
import { ErrorMessages, zFirstName, zLastName } from '../error-messages';

export const updateNameFormSchema = z
  .object({
    firstName: zFirstName,
    lastName: zLastName,
  })
  .refine(({ firstName, lastName }) => firstName && lastName, {
    message: ErrorMessages.Name.MISSING,
    path: ['fullName'],
  });

export type UpdateNameForm = z.TypeOf<typeof updateNameFormSchema>;
